import { PrivateLeaseStoreService } from '@hb/modules/financial-obligations/private-lease/private-lease-store.service';
import { Keys, QuestionKey } from '@hb/modules/global/global.constants';
import { AmountFormControl } from '@hb/domain';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { NextButtonComponent } from '@hb/modules';
import { CO_QUESTION_KEY, GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApContentPipe, ApContentService } from '@ap/content';
import { ErrorMessages } from '@ap/form/errors';
import { ApInputComponent } from '@ap/input';
import { ApInputConstraintDirective } from '@ap/input/constraint';

@Component({
    selector: 'private-lease-months',
    imports: [ApInputComponent, ApContentPipe, ReactiveFormsModule, NextButtonComponent, ApInputConstraintDirective],
    templateUrl: './private-lease-months.component.html',
    providers: [
        { provide: GLOBAL_STORE, useExisting: PrivateLeaseStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.PRIVATE_LEASE_MONTHS },
        { provide: CO_QUESTION_KEY, useValue: QuestionKey.PRIVATE_LEASE_MONTHS_CO_APPLICANT }
    ]
})
export class PrivateLeaseMonthsComponent extends GlobalInjectComponent<PrivateLeaseStoreService> implements OnInit {
    protected readonly analyticsService = inject(AnalyticsService);
    protected readonly contentService = inject(ApContentService);
    protected readonly store = inject(PrivateLeaseStoreService);

    protected readonly stripPattern = /[^\d]/g;
    protected errorMessages: ErrorMessages;

    constructor() {
        super();
        this.setErrorMessage();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new AmountFormControl<string>(
            this.analyticsService,
            this.store.getMainApplicantDurationInMonths()?.toString(),
            this.questionKey
        );
        this.mainApplicantControl.onUpdate().subscribe((months) => this.store.setMainApplicantDurationInMonths(+months));

        this.coApplicantControl = new AmountFormControl<string>(
            this.analyticsService,
            this.store.getCoApplicantDurationInMonths()?.toString(),
            this.coQuestionKey
        );
        this.coApplicantControl.onUpdate().subscribe((months) => this.store.setCoApplicantDurationInMonths(+months));
    }

    private setErrorMessage(): void {
        this.errorMessages = {
            required: this.contentService.get('general.error.number.required'),
            min: this.contentService.get(`general.error.number.min`, {
                number: Keys.getValidationAmount(this.questionKey, 'min').toString()
            }),
            max: this.contentService.get(`general.error.number.max`, {
                number: Keys.getValidationAmount(this.questionKey, 'max').toString()
            })
        } as ErrorMessages;
    }
}
